import {ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild} from '@angular/core';
import {GnTableConfig} from './TableConfig';
import {HttpClient} from '@angular/common/http';
import {GnTableComponent} from '../table/table.component';
import {ActivatedRoute} from '@angular/router';
import {GnMessageService} from '../message-service/message-service';
import {GnTableButtonComponent} from '../table-button/table-button.component';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {GnFormItem} from '../json-form/json-form-item/FormItem';

@Component({
  selector: 'gn-json-table',
  templateUrl: './json-table.component.html',
  styleUrls: ['./json-table.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => GnJsonTableComponent),
    multi: true
  }]
})
@GnFormItem('table')
export class GnJsonTableComponent implements OnInit, ControlValueAccessor {

  private changed = false;
  private configValue: GnTableConfig;
  private urlValue: string;

  @Input() set config(config: GnTableConfig) {
    this.configValue = config;
    this.changed = true;
  }

  get config(): GnTableConfig {
    return this.configValue;
  }

  @Input() set url(url: string) {
    this.urlValue = url;
    this.changed = true;
  }

  get url(): string {
    return this.urlValue;
  }

  @Output() configLoaded = new EventEmitter<GnTableConfig>();
  @Output() dataLoaded = new EventEmitter();

  @ViewChild(GnTableComponent) table: GnTableComponent;
  @ViewChild(GnTableButtonComponent) button: GnTableButtonComponent;

  constructor(private http: HttpClient,
              private messageService: GnMessageService,
              private changeDetectorRef: ChangeDetectorRef,
              private route: ActivatedRoute) {
    this.route.data
      .subscribe((data: any) => {
        this.url = data.url;
        this.loadConfig();
      });
  }

  ngOnInit() {
    this.loadConfig();
  }

  private loadConfig(): void {
    if (this.changed && this.url) {
      this.changed = false;
      this.http.get(this.url)
        .subscribe((resp: GnTableConfig) => {
            this.config = resp;
            this.changeDetectorRef.detectChanges();
            this.configLoaded.emit(this.config);
            if (this.config.autoLoadData === undefined || this.config.autoLoadData) {
              this.table.dataLoaded.subscribe(() => this.dataLoaded.emit());
              this.table.loadData();
            }
          },
          (err) => {
            this.messageService.error('获取表格配置错误');
            console.error(err);
          });
    }
  }

  valueChange = (value: any[]) => {
  }

  writeValue(obj: any[]): void {
    if (obj) {
      this.table.refreshData(obj);
    }
  }

  registerOnChange(fn: any): void {
    this.valueChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

}
